import React from "react";
import Row from "./common/Row";
import Field from "./common/Field";
import { StyleSheet, Text } from "@react-pdf/renderer";
import { config } from "./common/config";

const styles = StyleSheet.create({
  subtext: {
    color: config.grayColor,
    fontSize: config.normalFontSize + 1,
    marginBottom: 5,
  },

  subtitle: {
    width: "100%",
    borderBottomWidth: 2,
    borderBottomColor: "#118052",
    paddingBottom: 2,
    marginBottom: 4,
  },
  bottomBorder: {
    // borderBottomColor: config.grayColor,
    // borderBottomWidth: 1,
    backgroundColor: "#ffcf99",
    marginBottom: 10,
    paddingTop: 5,
    paddingLeft: 5,
  },
});

const Notes = ({ notes }) =>
  notes.map((msg, index) => (
    <React.Fragment key={Math.random()}>
      <Row style={styles.bottomBorder}>
        <Field label={`Texto`}>
          <Text style={styles.subtext}>{msg.data.text}</Text>
        </Field>
      </Row>
    </React.Fragment>
  ));

export default Notes;
